import { punchoutCookies } from "@/core/utilities/punchout/punchoutCookies";
import type { RouteRecordRaw } from "vue-router";

const Profile = () => import("@/pages/account/profile.vue");
const AccountInfo = () => import("@/pages/account/account-info.vue");
const Addresses = () => import("@/pages/account/addresses.vue");
const Orders = () => import("@/pages/account/orders.vue");
const OrderDetails = () => import("@/pages/account/order-details.vue");
const QuoteDetails = () => import("@/pages/account/quote-details.vue");
const Lists = () => import("@/pages/account/lists.vue");
const ListDetails = () => import("@/pages/account/list-details.vue");
const CheckoutDefaults = () => import("@/pages/account/checkout-defaults.vue");
const Quotes = () => import("@/pages/account/quotes.vue");
const Impersonate = () => import("@/pages/account/impersonate.vue");
const ProductNotifications = () => import("@/pages/account/product-notification.vue");
const SavedShoppingCarts = () => import("@/pages/account/saved-shopping-carts.vue");
const SavedShoppingCartsDetails = () => import("@/pages/account/saved-shopping-carts-detail.vue");
const RemoveAccount = () => import("@/pages/account/remove-account.vue");
const ContactUs = () => import("@/pages/account/contact-us.vue");
const SitePreferences = () => import("@/pages/thorlabs/site-preferences.vue");
const PaymentCards = () => import("@/pages/account/payment-cards.vue");

export const accountRoutes: RouteRecordRaw[] = [
  {
    path: "account-info",
    name: "AccountInfo",
    component: AccountInfo,
    beforeEnter(_to, _from, next) {
      if (punchoutCookies.value) {
        next({ path: "/404" }); // Redirect to not found page
      }
      next();
    },
  },
  { path: "profile", name: "Profile", component: Profile },
  {
    path: "remove-account",
    name: "RemoveAccount",
    component: RemoveAccount,
    beforeEnter(_to, _from, next) {
      if (punchoutCookies.value) {
        next({ path: "/404" }); // Redirect to not found page
      }
      next();
    },
  },
  { path: "contact-us", name: "ContactUs", component: ContactUs },
  { path: "site-preferences", name: "SitePreferences", component: SitePreferences },
  {
    path: "addresses",
    name: "Addresses",
    component: Addresses,
    beforeEnter(_to, _from, next) {
      if (punchoutCookies.value) {
        next({ path: "/404" }); // Redirect to not found page
      }
      next();
    },
  },
  {
    path: "orders",
    children: [
      { path: "", name: "Orders", component: Orders },
      {
        path: ":orderId",
        children: [
          {
            path: "",
            name: "OrderDetails",
            component: OrderDetails,
            props: true,
            meta: { hideLeftSidebar: false },
          },
        ],
        meta: { hideLeftSidebar: true },
      },
    ],
  },
  {
    path: "lists",
    children: [
      { path: "", name: "Lists", component: Lists },
      {
        path: ":listId",
        name: "ListDetails",
        component: ListDetails,
        props: true,
      },
    ],
  },
  { path: "checkout-defaults", name: "CheckoutDefaults", component: CheckoutDefaults },
  {
    path: "quotes",
    children: [
      { path: "", name: "Quotes", component: Quotes },
      {
        path: ":quoteId",
        children: [
          {
            path: "",
            name: "QuoteDetails",
            component: QuoteDetails,
            props: true,
            meta: { hideLeftSidebar: false },
          },
        ],
      },
    ],
    beforeEnter(_to, _from, next) {
      if (punchoutCookies.value) {
        next({ path: "/404" }); // Redirect to not found page
      }
      next();
    },
  },
  {
    path: "saved-shopping-carts",
    children: [
      {
        path: "",
        name: "SavedShoppingCarts",
        component: SavedShoppingCarts,
      },
      {
        path: ":cartId",
        children: [
          {
            path: "",
            name: "SavedShoppingCartsDetails",
            component: SavedShoppingCartsDetails,
            props: true,
            meta: { hideLeftSidebar: false },
          },
        ],
        meta: { hideLeftSidebar: true },
      },
    ],
    beforeEnter(_to, _from, next) {
      if (punchoutCookies.value) {
        next({ path: "/404" }); // Redirect to not found page
      }
      next();
    },
  },
  {
    path: "product-notifications",
    name: "ProductNotifications",
    component: ProductNotifications,
    beforeEnter(_to, _from, next) {
      if (punchoutCookies.value) {
        next({ path: "/404" }); // Redirect to not found page
      }
      next();
    },
  },
  {
    path: "impersonate/:userId",
    name: "Impersonate",
    props: true,
    component: Impersonate,
  },
  {
    path: "payment-cards",
    name: "PaymentCards",
    component: PaymentCards,
    beforeEnter(_to, _from, next) {
      if (punchoutCookies.value) {
        next({ path: "/404" }); // Redirect to not found page
      }
      next();
    },
  },
];
